import { Sparkles } from 'lucide-react';
import { useI18n } from '../lib/i18n';
import { TIDS } from '../constants/testIds';

const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={TIDS.footer}
      className="bg-white border-t border-black/5 py-14"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid grid-cols-1 sm:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <img
              src="/logo-icon.png"
              alt="Premium Laundry Services logo"
              className="w-9 h-9 object-contain"
            />
            <span className="font-semibold tracking-tight text-[#1D1D1F]">
              Premium Laundry Services
            </span>
          </div>
          <p className="mt-4 text-sm text-[#86868B] max-w-xs leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold tracking-wider uppercase text-[#1D1D1F]">
            {t.footer.contact}
          </p>
          <ul className="mt-4 space-y-2 text-sm text-[#86868B]">
            <li>info@premiumlaundryservices.org</li>
            <li>+1 (407) 487-0392</li>
            <li>Augusta, GA 30909</li>
          </ul>
        </div>

        <div className="sm:text-right">
          <p className="text-xs text-[#86868B]">
            © {year} Premium Laundry Services.
            <br />
            {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
